import { createActions } from 'redux-actions';

export const {
  businessUnit: { setBusinessUnitDetails },
}: any = createActions({
  BUSINESS_UNIT: {
    SET_BUSINESS_UNIT_DETAILS: (details) => ({
      details,
    }),
  },
});
